/* eslint-disable prettier/prettier */
/* eslint-disable */

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

// @mui icons

import { FaFacebookF, FaTiktok, FaInstagram, FaEnvelope } from 'react-icons/fa';  // Importer ikoner fra react-icons/fa


// Material Kit 2 React components
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";

// Images
import logo from "assets/images/logos/T-event/full-cropped-logo-fulllogo_transparent.png";

const date = new Date().getFullYear();

const footerRoutes = () => {
  return (
    <MKBox component="footer" py={6} px={2} sx={{ backgroundColor: "black", color: "white" }}>
      <Container>
        <Grid container spacing={6} alignItems="flex-start">
          {/* Venstre side: Logo med sosiale medier */}
          <Grid item xs={12} md={4}>
            <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
            {/* Logo */}
            <MKBox component="img" src={logo} alt="T-Events Logo" width="140px" height="auto" mb={2} />

            {/* Sosiale medier */}
            <Box display="flex" gap={2}>
              <MKBox component="a" href="https://www.facebook.com/teventservice" target="_blank">
                  <FaFacebookF style={{ color: "darkblue", fontSize: "18px" }} />
                </MKBox>
                <MKBox component="a" href="https://www.tiktok.com/@tevent.no" target="_blank">
                  <FaTiktok style={{ color: "darkblue", fontSize: "18px" }} />
                </MKBox>
                <MKBox component="a" href="https://www.instagram.com/teventno/?igsh=MXYwbTI2bzBjNGUyZg%3D%3D" target="_blank">
                  <FaInstagram style={{ color: "darkblue", fontSize: "18px" }} />
                </MKBox>
                <MKBox component="a" href="mailto:mathias@t-event.no" target="_blank">
                  <FaEnvelope style={{ color: "darkblue", fontSize: "18px" }} />
                </MKBox>
            </Box>
            </Box>
          </Grid>

          {/* Midten: Kontaktinfo */}
          <Grid item xs={12} md={4}>
            <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
              <MKTypography variant="h6" fontWeight="bold" mb={1}>Kontakt</MKTypography>
              <MKTypography variant="body2">E-post: <a href="mailto:mathias@t-event.no" >mathias@t-event.no</a></MKTypography>
              <MKTypography variant="body2">Telefon: <a href="tel:+4792963907">+47 929 63 907</a></MKTypography>
              <MKTypography variant="body2">Adresse: Steinbakken 13, 8610 Mo i Rana</MKTypography>
              <MKTypography variant="body2">Org.nr: 931 764 632</MKTypography>
            </Box>
          </Grid>

          {/* Høyre side: Navigasjonslenker */}
          <Grid item xs={12} md={4}>
            <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
              <MKTypography component="a" href="/om-oss" variant="button" sx={{ color: "white", textDecoration: "none", mb: 1, '&:hover': { color: "info.main" }}}>Hvem er T-Event?</MKTypography>
              <MKTypography component="a" href="/kontakt-oss" variant="button" sx={{ color: "white", textDecoration: "none", mb: 1, '&:hover': { color: "info.main" }}}>Send forespørsel!</MKTypography>
              <MKTypography component="a" href="/utleie" variant="button" sx={{ color: "white", textDecoration: "none", mb: 1, '&:hover': { color: "info.main" }}}>Våre tjenester</MKTypography>
    
             {//Kommentert ut for å vise senere når innhold kommer - BRANDS
             //  <MKTypography component="a" href="/brands" variant="button" sx={{ color: "white", textDecoration: "none", '&:hover': { color: "info.main" }}}>Våre events</MKTypography>
}
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box textAlign="center" mt={4}>
          <MKTypography variant="button" fontWeight="regular" sx={{ color: "white" }}>
            Utviklet av <MKTypography component="a" href="https://polarcode.solutions" target="_blank" rel="noreferrer" variant="button" sx={{ color: "info.main", textDecoration: "none" }}>PolarCode Solutions</MKTypography>.
            Copyright &copy; {date} for T-Event.
          </MKTypography>
        </Box>
      </Container>
    </MKBox>
  );
};

export default footerRoutes;